module.exports = __webpack_public_path__ + "static/media/image1.c87f0c50.png";